import * as React from "react";
import { NavLink, useLocation } from "react-router-dom";
import clsx from "clsx";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Menu, X } from "react-feather";
import { MenuItem } from "../../../../store/menuSlice";

interface FavoriteMenuItemProps {
  item: MenuItem;
  onUnpin: (id: string) => void;
  isEditMode: boolean;
}

export const FavoriteMenuItem: React.FC<FavoriteMenuItemProps> = ({ item, onUnpin, isEditMode }) => {
  const { pathname } = useLocation();
  const isActive = item.customIsActive ? item.customIsActive(pathname) : pathname.startsWith(item.url.split("?")[0]);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="favorite-menu-item">
      <div className="favorite-menu-item-content">
        {isEditMode && (
          <button
            className="favorite-menu-item-drag-handle"
            {...attributes}
            {...listeners}
            aria-label="Drag to reorder"
          >
            <Menu size={16} />
          </button>
        )}

        <NavLink
          to={item.url}
          tabIndex={isActive ? -1 : 0}
          className={clsx("favorite-menu-item-link", {
            selected: isActive,
            "edit-mode": isEditMode,
          })}
        >
          <div className="favorite-menu-item-link-content">
            {item.icon && <div className="menu-link-icon">{item.icon}</div>}
            <span>{item.label}</span>
          </div>
        </NavLink>

        {isEditMode && (
          <button
            className="favorite-menu-item-unpin"
            onClick={() => onUnpin(item.id)}
            aria-label="Unpin from favorites"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};
